export const generateUrlSafeBase64 = (length = 16) => {
    const randomBytes = new Uint8Array(length)
    window.crypto.getRandomValues(randomBytes)
    const base64 = btoa(String.fromCharCode.apply(null, randomBytes))
    const urlSafeBase64 = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
    return urlSafeBase64
}

export function isPrivateBrowsing() {
    try {
        const testKey = 'test-private'
        localStorage.setItem(testKey, '1')
        localStorage.removeItem(testKey)

        const largeSting = new Array(100000).join('x')
        localStorage.setItem(testKey, largeSting)
        localStorage.removeItem(testKey)

        return false
    } catch (e) {
        return true
    }
}

declare global {
    interface Window {
        CybozuLabs?: {
            MD5: {
                calc: (str: string, option?: any) => string
                BY_UTF16?: any
            }
        }
    }
}

export const calculateMD5 = (value: string): string | null => {
    if (value && window.CybozuLabs?.MD5?.calc) {
        try {
            return window.CybozuLabs.MD5.calc(value)
        } catch (error) {
            console.error('MD5計算エラー:', error)
            return null
        }
    }
    return null
}
